const AVATAR_STORAGE_PREFIX = 'whatsapp-contact-avatar:';
const AVATAR_STORAGE_META_PREFIX = 'whatsapp-contact-avatar-meta:';
const AVATAR_MAX_AGE_DAYS = 60;

const getAvatarStorageKey = (contatoId) => `${AVATAR_STORAGE_PREFIX}${String(contatoId)}`;
const getAvatarMetaStorageKey = (contatoId) => `${AVATAR_STORAGE_META_PREFIX}${String(contatoId)}`;

export const readAvatarFromStorage = (contatoId) => {
  if (!contatoId) return '';

  try {
    return localStorage.getItem(getAvatarStorageKey(contatoId)) || '';
  } catch {
    return '';
  }
};

export const saveAvatarToStorage = (contatoId, dataUrl) => {
  if (!contatoId || !dataUrl) return;

  try {
    localStorage.setItem(getAvatarStorageKey(contatoId), dataUrl);
    localStorage.setItem(getAvatarMetaStorageKey(contatoId), new Date().toISOString());
  } catch (error) {
    console.warn(`Nao foi possivel salvar avatar do contato ${contatoId} no localStorage.`, error);
  }
};

export const cleanupOldWhatsappAvatars = () => {
  const agora = Date.now();
  const maxAgeMs = AVATAR_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
  const keysToRemove = [];

  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!key || !key.startsWith(AVATAR_STORAGE_META_PREFIX)) continue;

    const savedAt = localStorage.getItem(key);
    const savedAtMs = savedAt ? new Date(savedAt).getTime() : Number.NaN;
    const contatoId = key.slice(AVATAR_STORAGE_META_PREFIX.length);

    if (!contatoId || Number.isNaN(savedAtMs) || (agora - savedAtMs) <= maxAgeMs) {
      continue;
    }

    keysToRemove.push(getAvatarStorageKey(contatoId));
    keysToRemove.push(key);
  }

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });
};

const whatsappAvatarStorage = {
  cleanupOldWhatsappAvatars,
  readAvatarFromStorage,
  saveAvatarToStorage,
};

export default whatsappAvatarStorage;
